import React from "react"
import {
	FormControl,
	InputLabel,
	Input,
	Button,
	FormControlLabel,
	Checkbox,
	CircularProgress,
	Dialog,
	DialogContent,
	DialogTitle,
	Card,
	CardActionArea,
	CardHeader,
	Grid,
	TextField,
	LinearProgress,
	Typography
} from "@material-ui/core"
import PrepressService from "../../services/pdfProof/PdfProofService"
import Background from "../../resources/img/new-pdfproof.png"
import {sendPDFViaCareforce} from "../../services/careforce/careforce"
import {validateEmailsSeparatedByComma} from "../../utils/validateEmail"
import {AlertWithStatus, WARNING_SEVERITY} from "../feedback/AlertWithStatus"
import {DesignServiceDependency, PdfProofActionTypes} from "../../services/designService/designService"

function PdfProof() {
	let press = new PrepressService()
	/* Get AldDocId from URL Parameters */
	const urlParams = new URLSearchParams(window.location.search)
	var altDocId = (urlParams.get("AltDocId") || "" ) as string
	const caseId = (urlParams.get("caseId") || "") as string
	const [prepressInstructionsUrl, setPrepressInstructionsUrl] = React.useState(
		(urlParams.get("PrepressInstructionsUrl") || "" )as string
	)
	const [state, setState] = React.useState({
		useWatermark: true,
	})
	//this function change the state of the checkbox
	const handleChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
		DesignServiceDependency.logAction(PdfProofActionTypes.UpdateWatermark)
		setState({...state, [name]: event.target.checked})
	}
	//used for the progress pop up
	const [open, setOpen] = React.useState(false)
	const [isPDFReady, setIsPDFReady] = React.useState(false)
	const [binaryPdf, setBinaryPdf] = React.useState('')
	const [email, setEmail] = React.useState((urlParams.get("emailAddress") || "")as string)
	const [validEmail, setValidEmail] = React.useState<any>(validateEmailsSeparatedByComma(urlParams.get("emailAddress") as string))
	const [sendingEmail, setSendingEmail] = React.useState(false)

	const [alertColor, setAlertColor] = React.useState("")
	const [alertOpen, setAlertOpen] = React.useState(false)
	const [alertMessage, setAlertMessage] = React.useState("")

	const handleAlert = (color: string, message: string) => {
		setAlertColor(color)
		setAlertMessage(message)
		setAlertOpen(true)
		setTimeout(() => {
			setAlertOpen(false)
		}, 6000)
		setSendingEmail(false)
	}

	//to close the progress pop up
	function handleClose() {
		setOpen(false)
		setIsPDFReady(true)
	}

	//to close the progress pop up
	async function sendProofByEmail() {
		if (!binaryPdf) {
			handleAlert(WARNING_SEVERITY.RED, "Invalid PDF file")
			return;
		}
		setSendingEmail(true)
		sendPDFViaCareforce(binaryPdf, caseId, email)
		.then(res=>{
			if (res) handleAlert(WARNING_SEVERITY.GREEN, "PDF Proof email sent successfully!")
			else handleAlert(WARNING_SEVERITY.RED, "Failed to email the PDF Proof")
		})
		.catch(err=>{
			handleAlert(WARNING_SEVERITY.RED, "Failed to email the PDF Proof")
		})
		
	}

	//the main button function that gets the pdf
	async function ShowRenderingUrl(useWatermark: boolean) {
		if (
			(document.getElementById("AltDocId") as HTMLInputElement).value === "" &&
			!prepressInstructionsUrl
		) {
			var errorLabel = document.getElementById("error-label") as HTMLElement
			errorLabel.innerText = " Please enter a Doc ID or Prepress Instructions URL"
			errorLabel.style.visibility = "visible"
			;(document.getElementById("AltDocId") as HTMLElement).style.color = "red"
		} else {
			setOpen(true)
			let AltDocId = (document.getElementById("AltDocId") as HTMLInputElement).value
			const binary = await press.GeneratePdfProofAsync(AltDocId, useWatermark, prepressInstructionsUrl)
			if (binary) setBinaryPdf(binary)
			if (press.completed) handleClose()
		}
	}

	return (
		<div>
			<AlertWithStatus color={alertColor} message={alertMessage} open={alertOpen} title={""} />
			<div
				style={{
					backgroundImage: "url(" + Background + ")",
					opacity: 0.1,
					zIndex: 0,
					height: 500,
					width: "100%",
					position: "absolute",
					minHeight: "100vh",
				}}
			></div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					margin: 20,
					padding: 20,

					position: "relative",
				}}
			>
				<form
					style={{
						backgroundColor: "#FFFFFE",
						width: "50%",
					}}
				>
					<h1>Care PDF Proof Generator</h1>
					<br/>
					<label style={{color: "#3f51b5", fontSize: "24px"}}>
						Generate a pdf proof from a Vistaprint template using a doc Id:
						<br />
					</label>
					<ol style={{lineHeight: "26px"}}>
						<li style={{paddingLeft: "10px"}}>
							Find the design on the Vistaprint website and save the template in the customer’s
							portfolio without making any changes
						</li>
						<li style={{paddingLeft: "10px"}}>
							Copy the design’s Identification # from the portfolio
						</li>
						<li style={{paddingLeft: "10px"}}>
							Paste the design’s Identification # in the PDF Proof Generator
						</li>
						<li style={{paddingLeft: "10px"}}>
							Uncheck the “Add watermark” box if you do not want a watermark on the PDF
						</li>
						<li style={{paddingLeft: "10px"}}>Click Generate PDF</li>
					</ol>
					<br/>
					<FormControl margin="normal" fullWidth>
						<InputLabel required={!!altDocId}>Doc ID 
							<span style={{fontSize: '11px', marginLeft:'3px'}}>
								(legacy documents)
							</span>
						</InputLabel>
						<Input id="AltDocId" type="text" value={altDocId && altDocId !== "null" && altDocId !== null ? altDocId : ""} required />
					</FormControl>
					<FormControl margin="normal" fullWidth>
						<InputLabel>Prepress Instructions URL</InputLabel>
						<Input
							id="PrepressInstructionsUrl"
							type="text"
							value={prepressInstructionsUrl}
							onChange={(e) => setPrepressInstructionsUrl(e.target.value)}
						/>
					</FormControl>
					<FormControlLabel
						control={
							<Checkbox
								color="primary"
								checked={state.useWatermark}
								onChange={handleChange("useWatermark")}
							/>
						}
						label="Add watermark"
					/>

					<Button
						style={{marginBottom: 20}}
						variant="contained"
						color="primary"
						fullWidth={true}
						size="large"
						onClick={() => ShowRenderingUrl(state.useWatermark)}
					>
						Generate PDF
					</Button>
					
					<Grid container direction='row' style={{justifyContent:'center', justifyItems: 'center'}}>
						<Grid item xs={6} >
							<TextField
								error={!validEmail && isPDFReady}
								id="outlined-error-helper-text"
								label="Email Address"
								onChange={(e) => {
									setEmail(e.target.value)
									setValidEmail(validateEmailsSeparatedByComma(e.target.value.trim()))
								}}
								disabled={!isPDFReady}
								fullWidth
								value={email}
								helperText={validEmail ? "" : <>Invalid email format <br/> Multiple emails are separated by comma</>}
								/>
						</Grid>
						<Grid item xs={6} style={{justifyContent:'center', justifyItems: 'center'}}>
							<Button
							style={{marginTop: 5, marginLeft: 5, marginRight: 10}}
							variant="contained"
							color="primary"
							fullWidth={true}
							size="large"
							disabled={!isPDFReady || binaryPdf.length >= 12000000|| !validEmail}
							onClick={sendProofByEmail}
						>
							Email PDF Proof to customer
							</Button>
							{ binaryPdf.length >= 12000000 && <Typography style={{marginTop: 5, marginLeft: 5, marginRight: 10, color: 'red'}}>PDF file is too large, please download the proof and email it to the customer from Careforce</Typography>}
						</Grid>
					</Grid>
					<br/>
					{sendingEmail && <LinearProgress></LinearProgress>}
					<label
						id="error-label"
						style={{
							color: "red",
							paddingTop: 5,
							visibility: "hidden",
							display: "block",
						}}
					>
						Error
					</label>

					
					
					<Card id="card_pdf_preview" style={{visibility: "hidden"}}>
						<CardActionArea>
							<CardHeader title="Preview" style={{textAlign: "center"}} />
							<iframe
								title="This is a unique title, never used but the compiler wants it "
								id="pdf_preview"
								style={{height: 500, width: "100%", borderWidth: 0}}
							></iframe>
						</CardActionArea>
					</Card>
				</form>

				<Dialog
					open={open}
					keepMounted
					aria-labelledby="alert-dialog-slide-title"
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{"Generating PDF Proof... "}
						{"This may take a while"}
					</DialogTitle>
					<DialogContent>
						<CircularProgress
							style={{
								justifyContent: "center",
								marginLeft: 155,
								marginBottom: 5,
								marginTop: 5,
							}}
							size={100}
						/>
					</DialogContent>
				</Dialog>
			</div>
		</div>
	)
}
export default PdfProof
